import { React, useEffect, useState } from "react";
import PosCashierNavbar from "../../Components/PosCashierNavbar";
import axios from "axios";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Loading from "../../Components/Loading";
import { setDivision } from "../../Redux/Action/division";
import LoadingSpinner from "../../Components/Loader/UploadLoader";

const CASHDROPS = ({ hideNavBar }) => {
  const dispatch = useDispatch();
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");

  const userState = useSelector((state) => state.changeTheState.user);
  const divisionState = useSelector((state) => state.changeDivision);
  const email = userState?.emailId;
  const loggedInUser = email?.split("@")?.[0]?.toUpperCase();

  const [division, setdivsion] = useState(divisionState);
  const [isloading, setisloading] = useState(true);
  const [company, setCompany] = useState({});

  // ---- Header fields ----
  const [docNo, setDocNo] = useState("");
  const [firstDocNo, setFirstDocNo] = useState("");
  const [latestDocNo, setLatestDocNo] = useState("");
  const [shiftNo, setShiftNo] = useState("");
  const [docDate, setDocDate] = useState(new Date());
  const [time, setTime] = useState(moment().format("HH:mm:ss"));

  // ---- Accounts (Object ID 1538) ----
  const [accountList, setAccountList] = useState([]);

  const [cashFloatAccount, setCashFloatAccount] = useState(null); // {ACCOUNTCODE, ACCOUNTNAME, CURRENCY}
  const [cashFloatExchRate, setCashFloatExchRate] = useState("");

  const [mainCashAccount, setMainCashAccount] = useState(null); // {ACCOUNTCODE, ACCOUNTNAME, CURRENCY}
  const [mainCashExchRate, setMainCashExchRate] = useState("");

  // ---- Amount / Narration ----
  const [amount, setAmount] = useState("");
  const [narration, setNarration] = useState("");

  // ---- Existing / New state ----
  const [historicDoc, setHistoricDoc] = useState(false);

  // ---- Doc No search popup ----
  const [docSearchPopup, setDocSearchPopup] = useState(false);
  const [docList, setDocList] = useState([]);
  const [search, setSearch] = useState("");

  // ---- Print ----
  const [pdfData, setPdfData] = useState(null);
  const [PopUpReport, setPopUpReport] = useState(false);
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);


    const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "24px",
      height: "24px",
      fontSize: "10px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "24px",
      padding: "0 8px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "24px",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "10px",
    }),
  };


  const customStyless = {
    control: (baseStyles) => ({
      ...baseStyles,
      minWidth: "220px",
      maxWidth: "220px",
      marginTop: "0px",
      minHeight: "initial",
      height: "30px",
      border: "1px solid",
      paddingBottom: "0px",
      paddingTop: "0px",
      backgroundColor: "white",
      color: "black",
      textTransform: "uppercase",
      "@media (max-width: 720px)": {
        minWidth: "181px",
      },
    }),
  };

  const authHeaders = {
    headers: {
      "auth-token": authToken,
      "session-token": sessiontoken,
    },
  };

  // ---------------------------------------------------------------------
  // INITIAL LOAD
  // ---------------------------------------------------------------------
  useEffect(() => {
    getCompanyDetails();
    initNewDoc();
    fetchAccounts();
    fetchAllDocs();
  }, []);

  const getCompanyDetails = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, authHeaders)
      .then((res) => setCompany(res?.data?.[0] || {}))
      .catch((err) => console.log("Error fetching company details", err));
  };

  // New Doc No -> Object ID 393
  const getNewDocNo = () => {
    return axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=393`, authHeaders)
      .then((res) => res?.data?.[0]?.JVNO || "")
      .catch((err) => {
        console.error("Error fetching new Doc No (393):", err);
        return "";
      });
  };

  // Shift No + Date -> Object ID 1810
  const getShiftAndDate = () => {
    return axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1810`, authHeaders)
      .then((res) => ({
        REFNO: res?.data?.[0]?.SHIFTNO || "",
        DOCDATE: res?.data?.[0]?.SHIFTDATE || new Date(),
      }))
      .catch((err) => {
        console.error("Error fetching Shift No / Date (1810):", err);
        return { REFNO: "", DOCDATE: new Date() };
      });
  };

  const initNewDoc = async () => {
    setisloading(true);
    const newDocNo = await getNewDocNo();
    const { REFNO, DOCDATE } = await getShiftAndDate();

    setDocNo(newDocNo);
    setLatestDocNo(newDocNo);
    setShiftNo(REFNO);
    setDocDate(DOCDATE);
    setTime(moment().format("HH:mm:ss"));
    setisloading(false);
  };

    // &PRESENTDATE=${presentDate}
  // Cash / Main accounts -> Object ID 1538, BANKCASH = "YES", present date
  const fetchAccounts = () => {
    const presentDate = moment().format("YYYY-MM-DD");
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandlerFunctionWithParamsFrom?viewname=1538&PRESENTDATE=${presentDate}`,
        authHeaders,
      )
        .then((res) => {
         const filterData = res?.data?.filter((item) => item?.["BANK CASH"] === "YES");
            setAccountList(filterData || [])
        })
      .catch((err) => console.error("Error fetching accounts (1538):", err));
  };

  // Full list of Cash Drop docs for the Doc No search popup
  // TODO: confirm object id for "all cash drops" list - reusing 442 unfiltered
  const fetchAllDocs = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=442`, authHeaders)
      .then((res) => {
        setDocList(res?.data || []);
        if (res?.data?.length) {
          setFirstDocNo(res.data[0].DOCNO);
        }
      })
      .catch((err) => console.error("Error fetching Doc list (442):", err));
  };

  // Exchange rate -> Object ID 1277 (currency + present date)
  const fetchExchRate = async (currency) => {
    if (!currency) return "";
    const presentDate = moment().format("YYYY-MM-DD");
    try {
      const res = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandlerFunctionWithParamsFrom?viewname=1277&CURRENCY=${currency}&PRESENTDATE=${presentDate}`,
        authHeaders,
      );
      return res?.data?.[0]?.EXCHRATE || "";
    } catch (err) {
      console.error("Error fetching Exch Rate (1277):", err);
      return "";
    }
  };

  // ---------------------------------------------------------------------
  // ACCOUNT SELECTION
  // ---------------------------------------------------------------------
  const handleCashFloatSelect = async (option) => {
    const acct = accountList.find((a) => a?.["ACCOUNT CODE"] === option.value);
    if (!acct) return;

    // If the same account is currently selected as Main Cash Account, block it
    if (mainCashAccount?.["ACCOUNT CODE"] === acct?.["ACCOUNT CODE"]) {
      alert(
        "This account is already selected as Main Cash Account. Please choose a different account.",
      );
      return;
    }

    setCashFloatAccount(acct);
    const rate = await fetchExchRate(acct.CURRENCY);
    setCashFloatExchRate(rate);
  };

  const handleMainCashSelect = async (option) => {
    const acct = accountList.find((a) => a?.["ACCOUNT CODE"] === option.value);
    if (!acct) return;

    // Cannot re-select the account already chosen as Cash Float Account
    if (cashFloatAccount?.["ACCOUNT CODE"] === acct?.["ACCOUNT CODE"]) {
      alert(
        "This account is already selected as Cash Float Account. Please choose a different account.",
      );
      return;
    }

    setMainCashAccount(acct);
    const rate = await fetchExchRate(acct.CURRENCY);
    setMainCashExchRate(rate);
  };

  // Options for Main Cash Account exclude whatever is chosen as Cash Float Account
  const mainCashOptions = accountList
    .filter((a) => a?.["ACCOUNT CODE"] !== cashFloatAccount?.["ACCOUNT CODE"])
    .map((a) => ({ label: a?.["ACCOUNT NAME"], value: a?.["ACCOUNT CODE"] }));

  // Options for Cash Float Account exclude whatever is chosen as Main Cash Account
  const cashFloatOptions = accountList
    .filter((a) => a?.["ACCOUNT CODE"] !== mainCashAccount?.["ACCOUNT CODE"])
    .map((a) => ({ label: a?.["ACCOUNT NAME"], value: a?.["ACCOUNT CODE"] }));

  // ---------------------------------------------------------------------
  // NAVIGATION (Doc No << < > >> / NEW), mirrors POSRECEIPT pattern
  // ---------------------------------------------------------------------
  const resetToNew = async () => {
    setHistoricDoc(false);
    setPdfData(null);
    setCashFloatAccount(null);
    setCashFloatExchRate("");
    setMainCashAccount(null);
    setMainCashExchRate("");
    setAmount("");
    setNarration("");
    await initNewDoc();
    fetchAllDocs();
  };

  const fetchDocDetails = (targetDocNo) => {
    setisloading(true);
    setPdfData(null);
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=442&DOCNO=${targetDocNo}`,
        authHeaders,
      )
      .then((res) => {
        const rows = res?.data || [];
        if (!rows.length) {
          setisloading(false);
          return;
        }

        const header = rows[0];
        const crRow = rows.find((r) => r.CRDR === "CR");
        const drRow = rows.find((r) => r.CRDR === "DR");

        setHistoricDoc(true);
        setDocNo(header.DOCNO);
        setShiftNo(header.REFNO);
        setDocDate(header.DOCDATE);
        setTime(header.TIME);
        setAmount(header.AMOUNT);
        setNarration(header.NARRATION);

        if (crRow) {
          const acct = accountList.find(
            (a) => a?.["ACCOUNT NAME"] === crRow?.ACCOUNTNAME,
          );
          setCashFloatAccount(
            acct || { ["ACCOUNT NAME"]: crRow?.ACCOUNTNAME, ["ACCOUNT CODE"]: "" },
            );
          fetchExchRate(acct?.CURRENCY).then(setCashFloatExchRate);
        }
        if (drRow) {
          const acct = accountList.find(
            (a) => a?.["ACCOUNT NAME"] === drRow?.ACCOUNTNAME,
          );
          setMainCashAccount(
            acct || { ["ACCOUNT NAME"]: drRow?.ACCOUNTNAME, ["ACCOUNT CODE"]: "" },
          );
          fetchExchRate(acct?.CURRENCY).then(setMainCashExchRate);
        }

        setisloading(false);
      })
      .catch((err) => {
        console.error("Error fetching Doc details (442):", err);
        setisloading(false);
      });
  };

  const handleButtonClick = (operation) => {
    if (operation === "first" && firstDocNo) {
      fetchDocDetails(firstDocNo);
    } else if (operation === "decrement" && docNo > firstDocNo) {
      fetchDocDetails(Number(docNo) - 1);
    } else if (operation === "increment" && docNo < latestDocNo) {
      fetchDocDetails(Number(docNo) + 1);
    } else if (operation === "latest" && latestDocNo) {
      fetchDocDetails(latestDocNo);
    }
  };

  const filteredDocList = docList.filter((item) => {
    if (!search) return true;
    const terms = search.toLowerCase().split(" ").filter(Boolean);
    return terms.every((term) =>
      ["DOCNO", "REFNO", "NARRATION"].some((key) =>
        String(item[key]).toLowerCase().includes(term),
      ),
    );
  });

  // ---------------------------------------------------------------------
  // SAVE  (SP ID 1832 header, then SP ID 1831 x2 for DR then CR)
  // ---------------------------------------------------------------------
  const validate = () => {
    if (!docNo) {
      alert("Kindly provide Doc No");
      return false;
    }
    if (!cashFloatAccount) {
      alert("Kindly select Cash Float Account");
      return false;
    }
    if (!mainCashAccount) {
      alert("Kindly select Main Cash Account");
      return false;
    }
    if (!amount || Number(amount) <= 0) {
      alert("Kindly enter a valid Amount");
      return false;
    }
    return true;
  };

  const saveHeader = async () => {
    // SP ID 1832
    return axios.post(
      `${BASEURL_GLOBAL}/globalSpHandler?spname=1832`,
      {
        DOCNO: docNo,
        JOURNALTYPE: "STANDARD",
        NEWEXISTING: historicDoc === true ? "EXISTING" : "NEW",
        CREATEDBY: loggedInUser,
      },
      authHeaders,
    );
  };

  // Voucher No -> Object ID 416
  const getVoucherNo = async () => {
    const res = await axios.get(
      `${BASEURL_GLOBAL}/globalViewHandler?viewname=416`,
      authHeaders,
    );
    return res?.data?.[0]?.LastVocNo || "";
  };

  const saveLine = (voucherNo, ddrcr, account, exchRate) => {
    // SP ID 1831
    return axios.post(
      `${BASEURL_GLOBAL}/globalSpHandler?spname=1831`,
      {
        VOUCHERNO: voucherNo,
        DOCNO: docNo,
        ACCOUNTCODE: account?.["ACCOUNT CODE"] || "",
        AMOUNT: Number(amount),
        CURRENCY: account?.CURRENCY || "",
        EXCHRATE: exchRate ? Number(exchRate) : 0,
        DOCDATE: moment(docDate).format("YYYY/MM/DD HH:mm:ss"),
        REFNO: shiftNo,
        ACCOUNTNAME: account?.["ACCOUNT NAME"] || "",
        VOUCHERJOURNALTYPE: "POS Cash Drops",
        LEDGERJOURNALTYPE: "POS Cash Drops",
        NARRATION: narration || "",
        USERID: loggedInUser,
        DIVISION: division,
        DDRCR: ddrcr,
      },
      authHeaders,
    );
  };

  const SaveCashDrop = async () => {
    if (!validate()) return;

    try {
      setisloading(true);

      const headerRes = await saveHeader();
      if (headerRes.status !== 201) {
        alert("Failed to save Cash Drop header");
        setisloading(false);
        return;
      }

      const voucherNo = await getVoucherNo();

      const drRes = await saveLine(
        voucherNo,
        "DR",
        mainCashAccount,
        mainCashExchRate,
      );
      const crRes = await saveLine(
        voucherNo,
        "CR",
        cashFloatAccount,
        cashFloatExchRate,
      );

      if (drRes.status === 201 && crRes.status === 201) {
        alert("Cash Drop Saved Successfully");
        setisloading(false);

        const isPrint = window.confirm("Do you want to print this Journal?");
        if (isPrint) {
          setPopUpReport(true);
          generateReport();
        } else {
          window.location.reload();
        }
      } else {
        alert("Failed to save Cash Drop lines");
        setisloading(false);
      }
    } catch (error) {
      console.error("Error saving Cash Drop:", error);
      alert(
        error?.response?.data?.message ||
          "Something went wrong while saving the Cash Drop",
      );
      setisloading(false);
    }
  };

  // ---------------------------------------------------------------------
  // PRINT  -> CrJournalApproved.rpt, param = Document Number
  // ---------------------------------------------------------------------
  const generateReport = () => {
    setPdfData(null);
    if (!docNo) {
      alert("Please select a Doc No");
      return;
    }
    setLoadingScreenBlock(true);
    axios
      .post(
        `${BASEURL}/generateReports`,
        {
          REPORTNAME: "CrJournalApproved.rpt",
          DOCNO: docNo,
          REPORTPATH: company?.REPORTPATH,
        },
        { ...authHeaders, responseType: "blob" },
      )
      .then((res) => {
        const file = new Blob([res.data], { type: "application/pdf" });
        setPdfData(URL.createObjectURL(file));
        setLoadingScreenBlock(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlock(false);
      });
  };

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "cash_drop_journal.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // ---------------------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------------------
  return (
    <>
      {!hideNavBar && <PosCashierNavbar />}
      {/* {isloading ? (
        <Loading />
      ) : ( */}
        <div className={`h-auto w-full ${hideNavBar ? "mt-10" : "mt-4"}`}>
          {/* Row 1: Doc No | Navigation Buttons | Cashier */}
          <div className="flex flex-wrap items-center gap-y-2 mt-2 ml-2">
            <p className="text-red-600 lg:ml-1">Doc No:</p>
            <input
              className="w-20 h-7 border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={docNo}
              readOnly
            />
            <button
              className="flex items-center h-7 justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-1 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setDocSearchPopup(true)}
            >
              ...
            </button>

            {docSearchPopup && (
              <div className="fixed top-[150px] left-1/2 -translate-x-1/2 z-50 bg-white border border-black h-[85vh] sm:h-[500px] w-[95%] sm:w-[90%] lg:w-[900px] p-1 overflow-y-auto rounded-md">
                <section className="lg:flex">
                  <div className="flex flex-wrap items-center mt-2 gap-2">
                    <p className="text-red-600">Search:</p>
                    <input
                      className="w-full sm:w-64 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <button
                      className="flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300 mx-2"
                      onClick={() => setDocSearchPopup(false)}
                    >
                      Close
                    </button>
                  </div>
                </section>
                <aside className="table__pos__app w-full overflow-x-auto">
                  <table class="custom-table">
                    <thead class="header-cell">
                      <tr>
                        <td>Doc No</td>
                        <td>Shift No</td>
                        <td>Doc Date</td>
                        <td>Amount</td>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDocList.map((row, index) => (
                        <tr
                          key={index}
                          onClick={() => {
                            setDocSearchPopup(false);
                            fetchDocDetails(row.DOCNO);
                          }}
                          className="border-b cursor-pointer text-sm table-row"
                        >
                          <td>{row.DOCNO || ""}</td>
                          <td>{row.REFNO || ""}</td>
                          <td>
                            {row.DOCDATE
                              ? moment(row.DOCDATE.split("T")[0]).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </td>
                          <td className="text-right">
                            {row.AMOUNT
                              ? Number(row.AMOUNT).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : ""}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </aside>
              </div>
            )}

            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3 mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => handleButtonClick("first")}
            >
              {"<<"}
            </button>
            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3 mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => handleButtonClick("decrement")}
            >
              {"<"}
            </button>
            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3 mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => handleButtonClick("increment")}
            >
              {">"}
            </button>
            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3 mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => handleButtonClick("latest")}
            >
              {">>"}
            </button>
           
            <p className="text-red-600 lg:ml-4">Cashier:</p>
            <input
              className="w-64 h-7 border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={loggedInUser || ""}
              readOnly
            />
          </div>

          {/* Row 2: Shift No | Date | Time | Save | Print */}
          <div className="flex flex-wrap items-center gap-1 mt-2 ml-2">
            <p className="text-red-600 lg:ml-1">Shift No:</p>
            <input
              className="w-20 h-7 border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={shiftNo}
              readOnly
            />
            <p className="text-red-600 lg:ml-2">Date:</p>
            <input
              className="w-32 h-7 border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={docDate ? moment(docDate).format("DD/MM/YYYY") : ""}
              readOnly
            />
            <p className="text-red-600 lg:ml-2">Time:</p>
            <input
              className="w-24 h-7 border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={time}
              readOnly
                  />
                   <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3 mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={resetToNew}
            >
              NEW
            </button>

            <button
              className="h-7 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-3 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={SaveCashDrop}
            >
              Save
            </button>
            <button
              className="h-7 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-1 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                if (!historicDoc) {
                  alert("Kindly Save the Journal first");
                } else {
                  setPopUpReport(true);
                  generateReport();
                }
              }}
            >
              Print
            </button>
          </div>

          {/* Row 3: Cash Float Account | Curr | Exch Rate */}
          <div className="flex flex-wrap items-center gap-1 mt-2 ml-2">
            <p className="text-red-600 lg:ml-1 w-40">Cash Float Account:</p>
            <Select
                      styles={customStyles}
                      className="w-80"
              onChange={handleCashFloatSelect}
              value={
                cashFloatAccount
                  ? {
                      label: cashFloatAccount?.["ACCOUNT NAME"],
                      value: cashFloatAccount?.["ACCOUNT CODE"],
                    }
                  : null
              }
              options={cashFloatOptions}
              isDisabled={historicDoc}
              placeholder="Select / search account..."
            />
            <p className="text-red-600 lg:ml-2">Curr:</p>
            <input
              className="w-20 h-7 border border-black ml-1 p-2 rounded-md bg-gray-100"
              value={cashFloatAccount?.CURRENCY || ""}
              readOnly
            />
            <p className="text-red-600 lg:ml-2">Exch Rate:</p>
            <input
              className="w-24 h-7 border border-black ml-1 p-2 rounded-md bg-gray-100"
              value={cashFloatExchRate}
              readOnly
            />
          </div>

          {/* Row 4: Main Cash Account | Curr | Exch Rate */}
          <div className="flex flex-wrap items-center gap-1 mt-2 ml-2">
            <p className="text-red-600 lg:ml-1 w-40">Main Cash Account:</p>
            <Select
                      styles={customStyles}
                      className="w-80"
              onChange={handleMainCashSelect}
              value={
                mainCashAccount
                  ? {
                      label: mainCashAccount?.["ACCOUNT NAME"],
                      value: mainCashAccount?.["ACCOUNT CODE"],
                    }
                  : null
              }
              options={mainCashOptions}
              isDisabled={historicDoc}
              placeholder="Select / search account..."
            />
            <p className="text-red-600 lg:ml-2">Curr:</p>
            <input
              className="w-20 h-7 border border-black ml-1 p-2 rounded-md bg-gray-100"
              value={mainCashAccount?.CURRENCY || ""}
              readOnly
            />
            <p className="text-red-600 lg:ml-2">Exch Rate:</p>
            <input
              className="w-24 h-7 border border-black ml-1 p-2 rounded-md bg-gray-100"
              value={mainCashExchRate}
              readOnly
            />
          </div>

          {/* Row 5: Amount | Narration */}
          <div className="flex flex-wrap items-center gap-1 mt-2 ml-2">
            <p className="text-red-600 lg:ml-1">Amount:</p>
            <input
              className="w-32 h-7 border border-black ml-1 p-2 rounded-md text-right focus:outline-none focus:border-blue-500"
              type="text"
              inputMode="decimal"
              value={amount}
              onChange={(e) => {
                const val = e.target.value;
                // numeric with up to 2 decimal places
                if (/^\d*\.?\d{0,2}$/.test(val)) setAmount(val);
              }}
              disabled={historicDoc}
            />
            <p className="text-red-600 lg:ml-4">Narration:</p>
            <textarea
              className="w-96 resize-none border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              rows={2}
                      type="text"
              value={narration}
              onChange={(e) => setNarration(e.target.value)}
              disabled={historicDoc}
            />
          </div>
        </div>
      {/* )} */}

      {/* Report Generation */}
      {PopUpReport && (
        <div>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 99,
            }}
          />
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              border: "1px solid black",
              height: "80%",
              width: "90%",
              maxWidth: "90%",
              maxHeight: "600px",
              padding: "16px",
              zIndex: 100,
              overflowY: "auto",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            {LoadingScreenBlock && <LoadingSpinner />}
            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setPopUpReport(false)}
            >
              Close
            </button>

            <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
              <section className="lg:hidden block">
                {pdfData && (
                  <button
                    className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                    onClick={handleDownload}
                  >
                    Download PDF
                  </button>
                )}
              </section>

              <section className="hidden lg:block">
                {pdfData ? (
                  <div className="mt-4">
                    <h2 className="text-lg font-bold">Generated Report</h2>
                    <iframe
                      src={pdfData}
                      title="Generated Report"
                      width="100%"
                      height="600px"
                    ></iframe>
                  </div>
                ) : (
                  <p className="text-2xl font-bold my-4 text-center">
                    No report available.
                  </p>
                )}
              </section>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default CASHDROPS;
